import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';

import { Button } from '@/components/ui/button/button.component';
import { partnerBranchDisplayName } from '@/utils/formatters/branch';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { Icon } from '@/components/ui/icon.component';
import { SearchType } from '@/types/most-search-type';

interface LaboratorialAttentionContentProps {
  searchType: string;
  schedule: SearchPartnerData;
  onChangeToDefaultContent: (value: boolean) => void;
  onClose: () => void;
}

export function LaboratorialAttentionContent({
  searchType,
  schedule,
  onChangeToDefaultContent,
  onClose,
}: LaboratorialAttentionContentProps) {
  const isVaccine = searchType === SearchType.VACCINE;
  const proceduresOfferedTitle = isVaccine ? 'Vacinas oferecidas por este local:' : 'Exames oferecidos por este local:';
  const proceduresNotOfferedTitle = isVaccine
    ? 'Vacinas não oferecidas por este local:'
    : 'Exames não oferecidos por este local:';
  const attentionContentTypeMessage = isVaccine
    ? 'não oferece todas as vacinas selecionadas'
    : 'não realiza todos os exames selecionados';

  const proceduresOffered = schedule.procedures.filter((procedure) => procedure.price !== undefined);
  const proceduresNotOffered = schedule.procedures.filter((procedure) => procedure.price === undefined);

  return (
    <div className="h-full flex flex-col justify-between gap-3">
      <section className="flex flex-col gap-6">
        <p data-testid="laboratorial-attention-content--message" className="text-gray-800">
          O
          {' '}
          {partnerBranchDisplayName(schedule.partner)}
          {' '}
          {attentionContentTypeMessage}
          .
        </p>

        <div className="flex flex-col gap-2">
          <p
            data-testid="laboratorial-attention-content--procedures-offered-title"
            className="text-gray-800 font-extrabold"
          >
            {proceduresOfferedTitle}
          </p>

          {proceduresOffered.map((procedure) => (
            <section key={procedure.id} className="flex gap-2">
              <Icon icon={faCheck} className="text-green-500 text-base self-start mt-1 " />
              <p className="text-green-500 text-base font-normal">{procedure.name}</p>
            </section>
          ))}
        </div>

        <div className="flex flex-col gap-2">
          <p
            data-testid="laboratorial-attention-content--procedures-not-offered-title"
            className="text-gray-800 font-extrabold"
          >
            {proceduresNotOfferedTitle}
          </p>
          {proceduresNotOffered.map((procedure) => (
            <section key={procedure.id} className="flex gap-2">
              <Icon icon={faXmark} className="text-danger-500 text-base self-start mt-1" />
              <p className="text-danger-500 text-base font-normal line-through">{procedure.name}</p>
            </section>
          ))}
        </div>
      </section>

      <section className="flex flex-col gap-4 px-6">
        <Button onClick={() => onChangeToDefaultContent(false)}>Ver horários</Button>

        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      </section>
    </div>
  );
}
